export const state = () => ({
  catalog: {
    items: [],
    loaded: false
  }
})

export const getters = {
  ITEMS: state => state.catalog.items,
  LOADED: state => state.catalog.loaded
}

export const mutations = {
  SET(state, catalog) {
    state.catalog.items = catalog
    state.catalog.loaded = true
  }
}
